import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './teambuilding.json'; // The JSON you provided

const Teambuilding = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Team dynamics, collaboration vocabulary, and workplace English. B2 level grammar, reading, and speaking exercises."
            level="B2"
            title="Team Building"
            image="/Images/argue4.webp"
            seoTitle="Free English Lesson Plans: Team Building"
            seoDescription="Team dynamics, collaboration vocabulary, and workplace English. B2 level grammar, reading, and speaking exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Teambuilding;


